import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Box, SxProps, Theme } from '@mui/material';

interface MarkdownDisplayProps {
  content: string;
  sx?: SxProps<Theme>;
}

export const MarkdownDisplay: React.FC<MarkdownDisplayProps> = ({ content, sx }) => {
  return (
    <Box
      sx={{
        '& p': { m: 0, mb: 1, '&:last-child': { mb: 0 } },
        '& ul, & ol': { m: 0, mb: 1, pl: 2 },
        '& li': { mb: 0.5 },
        '& h1, & h2, & h3, & h4, & h5, & h6': { mt: 1.5, mb: 1, fontWeight: 600 },
        '& blockquote': {
          borderLeft: '3px solid',
          borderColor: 'divider',
          pl: 1,
          ml: 0,
          fontStyle: 'italic',
        },
        '& code': {
          fontFamily: 'monospace',
          backgroundColor: 'action.hover',
          px: 0.5,
          borderRadius: 0.5,
          fontSize: '0.875em',
        },
        '& pre': {
          m: 0,
          mb: 1,
          p: 1,
          borderRadius: 1,
          backgroundColor: 'action.hover',
          overflowX: 'auto',
          '& code': {
            backgroundColor: 'transparent',
            p: 0,
          },
        },
        ...sx,
      }}
    >
      <ReactMarkdown>{content}</ReactMarkdown>
    </Box>
  );
};
